import { styled } from "@mui/material/styles";
import { Stack, Box } from "@mui/material";

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => !["isDragging", "draggableStyle"].includes(prop),
})(({ theme, isDragging, draggableStyle }) => ({
  backgroundColor: theme.palette.hubColors.white,
  width: "100%",
  borderRadius: "10px",
  zIndex: 1,
  ...draggableStyle,
  ...(isDragging && {}),
}));

export const StyledStack = styled(Stack)({
  position: "relative",
  gap: "0px",
});

export const StyledDroppablesContainer = styled(Stack)(({ theme }) => ({
  position: "relative",
  flexDirection: "row",
  justifyContent: "start",
  height: "calc(100vh - 0px - 51.47px)",
  backgroundColor: theme.palette.hubColors.greyLightest,
  gap: "10px",
  padding: "20px",
  overflowX: "auto",
  overflowY: "hidden",
}));

export const StyledPlaceholderStack = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  borderRadius: "10px",
  padding: "15px 30px",
  height: "70px",
  width: "100%",
  border: "1px dashed",
  borderColor: theme.palette.hubColors.mainFocus,
  backgroundColor: theme.palette.hubColors.mainFocusLightest,
}));

export const StyledPlaceholderDiv = ({
  placeholderProps,
  disabled = false,
}) => {
  return placeholderProps && !disabled
    ? {
        position: "absolute",
        top: placeholderProps.clientYInvert,
        left: placeholderProps.clientX,
        height: placeholderProps.clientHeight,
        width: placeholderProps.clientWidth,
        boxSizing: "border-box",
        borderRadius: "4px",
        border: "1px dashed",
        borderColor: "rgba(0, 122, 253, 1)",
        backgroundColor: "rgba(0, 122, 253, 0.08)",
        zIndex: 0,
      }
    : { display: "none" };
};
